// extracted by mini-css-extract-plugin
export default {"block":"FavoriteBlock_block__mQyzk"};